module.exports = __webpack_public_path__ + "img/cray.48130bb1.png";